import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getLocationPath } from 'lib/assets/assets_helpers';
import { getCompany, getSubcompany } from 'auth/selectors';
import * as List from 'selectors/lists';
import { getAsset, getIsLoadingForm } from 'selectors/assets';
import { getAssetsFormConfig } from 'containers/assets/actions';

class AssetFormConfig extends PureComponent {
  static propTypes = {
    render: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.getAssetsFormConfig(this.props.company.id, this.props.subcompany.id);
  }

  render = () =>
    this.props.render({
      ...this.props,
    });
}

const mapStateToProps = (state) => {
  const asset = getAsset(state);
  const accountId = asset._account && asset._account.id;
  const sublocations = getLocationPath(asset).map((location) =>
    List.makeVisibleSublocations()(state, { location })
  );

  return {
    accounts: List.getVisibleAccountsParent(state),
    subaccounts: List.makeGetVisibleSubaccounts()(state, { accountId }),
    asset,
    catalogs: List.getCatalogsAndVisibleElements(state),
    company: getCompany(state),
    costCenters: List.getVisibleCostCenters(state),
    employees: List.getVisibleEmployees(state),
    isLoading: getIsLoadingForm(state),
    locations: List.getVisibleLocationsParent(state),
    sublocations,
    projects: List.getVisibleProjects(state),
    providers: List.getVisibleProviders(state),
    subcompany: getSubcompany(state),
    inpcs: List.getInpcs(state),
    depreciations: List.getVisibleDepreciations(state),
    asset_levels: List.getVisibleAssetLevels(state),
  };
};

const mapDispatchToProps = { getAssetsFormConfig };

export default connect(mapStateToProps, mapDispatchToProps)(AssetFormConfig);



// WEBPACK FOOTER //
// src/containers/assets/AssetsFormConfig.js